import { SelectedPacket } from 'components/enrollForm'
import { Order } from 'storeTypes'
export const ordersAreDifferent = (
    goalItems: Order[],
    selectedPackets: SelectedPacket[]
) => {
    if (!goalItems && !selectedPackets) return false
    if (goalItems?.length !== selectedPackets?.length) {
        return true
    }

    const countByPackageId = (
        items: Array<{ package_id: string }>
    ): Map<string, number> => {
        const counts = new Map<string, number>()
        for (const item of items) {
            const id = item.package_id
            counts.set(id, (counts.get(id) ?? 0) + 1)
        }
        return counts
    }

    const goalCounts = countByPackageId(goalItems ?? [])
    const selectedCounts = countByPackageId(selectedPackets ?? [])

    if (goalCounts.size !== selectedCounts.size) return true

    for (const [packageId, count] of goalCounts) {
        if (selectedCounts.get(packageId) !== count) return true
    }
    return false
}
